var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-empty',{scopedSlots:_vm._u([{key:"description",fn:function(){return [_c('span',[_vm._v(" "+_vm._s(_setup.props.description)+" ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }